import { read_bulk } from '@bighealth/api/SceneSetGraph/v1';

import { getQueryClient } from 'components/ProvidersContainer/getQueryClient';

export const queryClientSceneSetGraphsBulk = async ({
  ids,
}: {
  ids: number[];
}): Promise<read_bulk.Response> => {
  const result = await getQueryClient().fetchQuery(
    read_bulk.queryKey,
    () =>
      read_bulk({
        entity_ids: ids,
      }),
    {
      cacheTime: Infinity,
    }
  );
  return result;
};
